﻿const CONSTANTS = {

    PACKAGE_TYPES:{
        'My Packaging': '02',
        'UPS Envelope': '01',
        'UPS Express Box': '21',
        'UPS Tube': '03',
        'UPS Pak': '04',
        'Pallet': '30'
    },
    COUNTRIES:{
        'Latvia': "628"
    },
    POPULAR_COUNTRIES: [
        "Latvia", "France", "Germany", "United Kingdom", "United States"
    ],
    NAVIGATION_LINKS: {
        shipping: '/shipdetails',
        summary: '/checkout',
        payment: '/paymentresult',
        do_ship:'/doship'
    },
    PROGRESS_KEY: 'NavigationProgress'
}

export default CONSTANTS;